import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";
import { useT } from "@/i18n_extra3";

const Counter = ({ value, prefix = "", suffix = "", decimals = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(decimals ? "0.0" : "0");
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.8,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(decimals ? v.toFixed(decimals) : String(Math.round(v))),
    });
    return () => controls.stop();
  }, [inView, value, decimals]);
  return (
    <span ref={ref} className="font-display font-bold text-5xl sm:text-6xl tracking-tight text-[#B8860B]">
      {prefix}{display}{suffix}
    </span>
  );
};

export const Stats = () => {
  const t = useT();
  return (
    <section className="py-20 sm:py-24 bg-[#F3F1EC] border-b border-black/5" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex items-center gap-3 mb-10">
          <span className="h-px w-10 bg-[#B8860B]" />
          <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#B8860B]">{t.stats.label}</span>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          {t.stats.items.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`stat-item-${i}`}
            >
              <Counter value={s.value} prefix={s.prefix || ""} suffix={s.suffix || ""} decimals={s.decimals || 0} />
              <div className="mt-2 text-sm text-black/55 font-medium">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
